import type { JsonObject } from "@/types/json"

import type { ShortcutAction } from "./KeyboardShortcutsContext"

export function areShortcutStatesEqual(
  leftState: JsonObject | undefined,
  rightState: JsonObject | undefined,
) {
  if (!leftState && !rightState) {
    return true
  }

  return JSON.stringify(leftState ?? {}) === JSON.stringify(rightState ?? {})
}

export function areShortcutsEqual(left: ShortcutAction, right: ShortcutAction) {
  return (
    left.action === right.action &&
    left.key === right.key &&
    left.label === right.label &&
    areShortcutStatesEqual(left.state, right.state)
  )
}
